import React from 'react';
import { Route } from 'react-router';

import Page from './component';

export default <Route
    exact
    key="404"
    path="/404"
    component={Page} />;